import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import { prototype } from 'react-fontawesome'

class FolderMenu extends React.Component {

   constructor(props) {
      super(props)
      this.state = {
         // selectedFolderName: ''
      }
      this.optionSelected = this.optionSelected.bind(this)
   }

   // // Default to index 0 selectio on mount
   // UNSAFE_componentWillMount() {
   //    this.optionSelected('historico')
   // }

   optionSelected(selectedFolderName) {
      const { onOptionSelect } = this.props
      // this.setState({ selectedFolderName: selectedFolderName })
      onOptionSelect(selectedFolderName)
   }

   render() {
      const { children, folders, selectedFolder } = this.props

      return (
         <div className="FolderMenu">
            <nav>
               {Object.keys(folders).map((attribute, index) => {
                  if (folders[attribute].show === true) {
                     return (
                        <div className={`FolderMenuOption ${attribute === selectedFolder ? 'selected' : ''}`}
                           key={index}
                           onClick={this.optionSelected.bind(null, attribute)}>
                           {folders[attribute].label}
                        </div>
                     )
                  }
               })}
            </nav>
            <header>
               {folders[selectedFolder]?<h1>{folders[selectedFolder].label}</h1>:null}
            </header>
            <section>
               {children}
            </section>
         </div>
      )
   }
}
FolderMenu.propTypes = {
   folders: PropTypes.object.isRequired,
   onOptionSelect: PropTypes.func.isRequired,
   children: PropTypes.any.isRequired,
}

export default FolderMenu



// WEBPACK FOOTER //
// ./src/components/FolderMenu/index.js